import React from 'react';
import { Box, Typography, Link, Paper, Divider } from '@mui/material';
import { YellowBoxBottom } from './Home';
import JoinUsBox from '../../components/JoinUsBox';
import Masonry from '@mui/lab/Masonry';

const SectionCard = ({ title, children }) => (
  <Box
    sx={{
      border: '1px solid #e0e0e0',
      p: 2.5,
      width: { xs: '100%', sm: '48%', md: '48%' },
      boxSizing: 'border-box',
      backgroundColor: 'transparent',
    }}
  >
    <Typography variant="h3" gutterBottom sx={{ textAlign: 'center' }}>
      {title}
    </Typography>
    <Typography variant="homePageBody" whiteSpace="pre-line">
      {children}
    </Typography>
  </Box>
);

const TermsSection = () => {
  return (
    <Box>
      {/* <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: 'row',
          gap: 2,
          // justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      > */}
      <Masonry columns={2} spacing={2}>
        <SectionCard title="Acceptance of Terms">
          By accessing or using{' '}
          <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span>, you
          agree to be bound by these Terms and our Privacy Policy. If you do not
          agree, please refrain from using our services.
        </SectionCard>

        <SectionCard title="Eligibility">
          You must be at least 18 years old, or the age of legal majority in
          your jurisdiction, to use{' '}
          <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span>. By
          using our platform, you represent meet these eligibility requirements.
        </SectionCard>

        <SectionCard title="User Accounts and Security">
          • You are responsible for maintaining the confidentiality of your
          account and any associated information.
          {'\n'}• You agree to provide accurate, complete, and updated
          information for your account.
          {'\n'}• You may add family members under your account for personalized
          readings, but you must have their consent.
        </SectionCard>

        <SectionCard title="AI-Powered Interactions">
          Our chat system includes predictive and interactive tools. While our
          AI is highly trained on spiritual, cultural, and empirical knowledge,
          its suggestions are not deterministic. By using it, you understand the
          limitations of AI interpretation.
        </SectionCard>

        <SectionCard title="Use of Services">
          <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span> provides
          personalized astrological insights, predictions, classical texts and
          AI-enhanced analysis. You agree to use the platform:
          {'\n'}• For lawful, non-commercial purposes.
          {'\n'}• Without impersonating others or submitting false data.
          {'\n'}• Without violating any local, national, or international laws.
          {'\n\n'}Astrological predictions are not to be treated as absolute
          truths or a substitute for legal, medical, or professional advice.
        </SectionCard>

        <SectionCard title="Intellectual Property">
          All content, including software, logos, text, designs, algorithms, and
          remedies, is the property of{' '}
          <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span> or its
          licensors and is protected by copyright and intellectual property
          laws. Do not reproduce, redistribute, or exploit any part of our
          platform without express written consent.
        </SectionCard>

        <SectionCard title="Subscription, Payment & Refunds">
          If you subscribe to any paid features:
          {'\n'}• Fees are clearly stated and billed in advance.
          {'\n'}• No refunds will be provided once the service has been used in
          insights accessed unless required by law.
          {'\n'}• We reserve the right to change our pricing model with prior
          notice.
        </SectionCard>

        <SectionCard title="Indemnification">
          You agree to defend, indemnify, and hold harmless{' '}
          <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span> and its
          affiliates, employees, and agents from any claims, liabilities,
          damages, losses, and expenses arising out of your use of the Services
          or breach of these Terms.
        </SectionCard>

        <SectionCard title="Disclaimers & Limitation of Liability">
          <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span> provides
          insights for informational and spiritual growth purposes only. We do
          not guarantee any specific outcomes. You agree that:
          {'\n'}• Use of{' '}
          <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span> is at
          your sole risk.
          {'\n'}• We are not liable for any indirect, incidental, or
          consequential damages from your use.
        </SectionCard>

        <SectionCard title="Modifications">
          We may update these Terms occasionally. Continued use of the Services
          following changes constitutes your acceptance. We encourage you to
          review this page periodically.
        </SectionCard>

        <SectionCard title="Sale of Gemstones & Remedies">
          We aim to bring transparency to the unregulated gemstone and
          astrological remedy market. We only offer items verified for
          authenticity. However, any purchase is made at your discretion, and
          <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span> does not
          guarantee outcomes from the use of such items.
        </SectionCard>

        <SectionCard title="Contact Us">
          For questions, feedback, or legal inquiries, please contact us at:
          {'\n'}📩 Email:{' '}
          <Link href="mailto:support@kaliyugai.com" color="secondary">
            support@kaliyugai.com
          </Link>
        </SectionCard>

        <SectionCard title="Termination">
          We may suspend or terminate your account if:
          {'\n'}• You violate these Terms.
          {'\n'}• We suspect fraudulent behavior.
          {'\n'}• Your use poses a risk to other users or the integrity of the
          platform.
          {'\n\n'}You can raise an account deletion request anytime by writing
          to us.
        </SectionCard>

        <SectionCard title="Governing Law & Jurisdiction">
          These Terms are governed by the laws of India. All disputes shall be
          subject to the jurisdiction of the courts in Delhi, India.
        </SectionCard>
      </Masonry>
      {/* </Box> */}
    </Box>
  );
};

const LegalTerms = () => {
  return (
    <Box>
      <Typography variant="homePageBody" paragraph>
        Welcome to <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span>
        . These Terms of Service (“Terms”) represent a legally binding agreement
        between you and{' '}
        <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span> regarding
        your access to and use of our services, which include our website,
        applications, APIs, tools, and any associated content (collectively
        referred to as “Services”). By accessing or using the Services, you
        affirm that you have read, understood, and agreed to these Terms. If you
        do not agree, you must discontinue use of the Services immediately.
        <br />
        You must be at least 18 years old to use the Services. If you are under
        18, you may only use the Services under the supervision of a parent or
        legal guardian who agrees to these Terms on your behalf. By using
        <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span>, you
        confirm that you are not located in any country subject to international
        embargoes or government restrictions and are not on any governmental
        list of prohibited individuals.
        <br />
        To utilize certain features of{' '}
        <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span>, such as
        personalized horoscopes, gemstone recommendations, or accessing
        astrologer consultations, you may need to create an account. You are
        responsible for maintaining the confidentiality of your login
        credentials and any activity conducted through your account.{' '}
        <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span> will not
        be held responsible for unauthorized use of your account, and you agree
        to notify us immediately of any breach of security or unauthorized
        activity.
        <br />
        <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span> grants you
        a limited, non-exclusive, non-transferable, revocable license to access
        and use the Services for your personal, non-commercial use in accordance
        with these Terms. You may not copy, modify, distribute, sell, lease,
        reverse-engineer, or otherwise exploit our platform or its content
        without prior written authorization. The Services may not be used for
        any unlawful, abusive, or fraudulent purposes, or in ways that interfere
        with the performance of{' '}
        <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span>’s systems
        or the experience of other users.
      </Typography>

      <Typography variant="homePageBody" paragraph>
        All content and intellectual property rights relating to our platform
        including but not limited to text, graphics, logos, algorithms, audio,
        video, AI models, databases, and branding belong solely to{' '}
        <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span> or its
        licensors and are protected by international copyright, trademark, and
        patent laws. You may not use, reproduce, or distribute our content for
        any commercial or public purpose without obtaining explicit permission.
        <br />
        By submitting any content to our Services be it feedback, questions, or
        user-generated content you grant{' '}
        <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span> a
        non-exclusive, royalty-free, worldwide license to use, display, store,
        reproduce, modify, and share that content as needed to operate and
        enhance the Services. You are solely responsible for any data or content
        you share and must ensure it does not violate the rights of any third
        party or applicable laws.
        <br />
        <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span> is
        committed to protecting your personal information. Our Privacy Policy
        governs how we collect, use, store, and share your data and is
        incorporated into these Terms by reference. While we employ advanced
        encryption and cybersecurity measures, no platform can guarantee
        complete security. By using the Services, you acknowledge and accept
        this inherent risk.
      </Typography>

      <Typography variant="homePageBody" paragraph>
        The Services are provided “as is” and “as available,” without warranties
        of any kind either express or implied.{' '}
        <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span> does not
        guarantee that its astrological or gemstone recommendations, AI
        insights, or life guidance will be error-free, completely accurate, or
        suitable for every purpose. We disclaim all liability for any decisions
        made based on the insights or data received from the platform.
        <br />
        In no event shall{' '}
        <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span> be liable
        for any indirect, incidental, special, consequential, or exemplary
        damages, including loss of profits, data, reputation, or other
        intangible losses, arising out of or in connection with your use of the
        Services. This applies even if{' '}
        <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span>
        has been advised of the possibility of such damages.
        <br />
        We reserve the right to change, suspend, or discontinue any part of the
        Services at any time, with or without notice. These changes may include
        adding or removing features or restricting access to parts of the
        Services. Continued use of the Services after any updates constitutes
        your acceptance of those changes.
        <br />
        You may terminate your account at any time by following the instructions
        provided in your settings. We also reserve the right to suspend or
        terminate access to the Services if we believe you have violated these
        Terms, caused harm to other users or the platform, or if your usage
        poses legal, financial, or security risks.
        <br />
        These Terms are governed by the laws of India. In the event of any
        dispute arising from or related to the Services or these Terms, both
        parties agree to resolve the issue through binding arbitration in New
        Delhi, in accordance with the Arbitration and Conciliation Act, 1996.
        You waive any right to a jury trial or to participate in a class action.
      </Typography>

      <Typography variant="homePageBody" paragraph>
        If any provision of these Terms is found to be unenforceable or invalid
        under applicable law, the remaining provisions will continue in full
        force and effect. Our failure to enforce any part of the Terms shall not
        be considered a waiver of our rights.
        <br />
        If you have any questions or concerns about these Terms, we welcome you
        to contact us via email or postal mail. Your trust and cooperation are
        essential to us as we continue building{' '}
        <span style={{ fontFamily: 'SpaceGrotesk' }}>KaliyugAi</span> into a
        platform that bridges the sacred wisdom of Vedic astrology with the
        evolving possibilities of artificial intelligence.
      </Typography>
      <Divider />
      <TermsSection />
      <JoinUsBox />
    </Box>
  );
};

export default LegalTerms;
